import { render, staticRenderFns } from "./StrictChooser.vue?vue&type=template&id=55a51f5a&scoped=true"
import script from "./StrictChooser.vue?vue&type=script&lang=ts"
export * from "./StrictChooser.vue?vue&type=script&lang=ts"
import style0 from "./StrictChooser.vue?vue&type=style&index=0&id=55a51f5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a51f5a",
  null
  
)

export default component.exports